import React from 'react';
import {
  Container,
  Typography,
  Box,
  Link,
  styled,
} from '@mui/material';
import { motion } from 'framer-motion';

const StyledContactSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  backgroundColor: theme.palette.background.default,
  textAlign: 'center',
}));

const ContactSection = () => {
  const email = 'CloudXviiDevelopment@outlook.com';

  return (
    <StyledContactSection>
      <motion.div
        initial={{ y: 50, opacity: 0 }} // Starts slightly below and invisible
        whileInView={{ y: 0, opacity: 1 }} // Animates to its final position when in view
        transition={{ duration: 0.8, ease: "easeInOut" }}
        viewport={{ once: true, amount: 0.5 }} // Triggers once when 50% of the component is visible
      >
        <Container maxWidth="md">
          <Typography variant="h3" component="h2" fontWeight="bold" gutterBottom>
            Let’s build something amazing together!
          </Typography>

          <Typography variant="h5" sx={{ mt: 4 }}>
            📩 Email:
            <Link
              href={`mailto:${email}`}
              color="secondary"
              underline="hover"
              sx={{ ml: 1, fontWeight: 'bold' }}
            >
              {email}
            </Link>
          </Typography>

          {/* You can add a phone number or other info here if you want */}
          {/*
          <Typography variant="h5" sx={{ mt: 2 }}>
            📞 Phone:
            <Link href="tel:555-555-5555" color="secondary" underline="hover" sx={{ ml: 1, fontWeight: 'bold' }}>
              [Optional]
            </Link>
          </Typography>
          */}
        </Container>
      </motion.div>
    </StyledContactSection>
  );
};

export default ContactSection;